module.exports = __webpack_public_path__ + "static/media/template3.86b24e5a.webp";